export default __webpack_public_path__ + "static/media/member2.24331b4f.jpg";